export const AGENT_THREAD_FLOW: Record<
  Thread.AgentId,
  {
    id: Thread.Data["graphId"];
    suggestions: Array<string | { title: string; message: string }>;
    welcomeMessage: string;
    inputPlaceholder?: string;
    welcomeSubMessages?: string[];
    suggestionCountToShow: number;
    flowTypes?: Record<string, string>;
    alignInputIfEmpty?: boolean;
  }
> = {
  talk_to_the_data: {
    id: "talk_to_the_data",
    welcomeMessage: "component.agent.talk_to_data.title",
    welcomeSubMessages: [
      "component.agent.talk_to_data.subtitle.dashboard_name",
      // "component.agent.talk_to_data.subtitle.discover",
    ],
    inputPlaceholder: "component.agent.talk_to_data.input.ask_followup",
    suggestionCountToShow: 4,
    suggestions: [
      {
        title: "Biggest YoY Growth",
        message: "Who had the biggest YoY growth in share of search",
      },
      {
        title: "Seasonal Event Impact",
        message: "Impact of seasonal events on searches",
      },
      {
        title: "News Impact",
        message:
          "Investigate the impact of news on search patterns last three months",
      },
      {
        title: "YoY Changes",
        message: "Tell me about the biggest year-over-year search changes",
      },
      {
        title: "Current Trends",
        message: "What is trending the most right now",
      },
      {
        title: "Peak Analysis",
        message: "Analyze the search peaks and their primary drivers",
      },
      {
        title: "Market Sentiment",
        message: "What are the sentiment factors driving search engagement",
      },
      {
        title: "Top Search Terms",
        message: "Investigate the top 3 highest-volume search terms",
      },
      {
        title: "Biggest Recent Growth",
        message: "Analyze the biggest search volume growth from previous month",
      },
      {
        title: "Seasonal Patterns",
        message:
          "What are the seasonal spikes in search interest last three years",
      },
      {
        title: "Peak Months",
        message: "Investigate the top 5 peak months for search volume",
      },
      {
        title: "Trending Terms",
        message: "Analyze top trending search terms over the last three months",
      },
      {
        title: "Quarterly Leaders",
        message: "What are the topics that dominate this quarter",
      },
      {
        title: "Competitor Gains",
        message:
          "Analyze which competitors gained the most search interest the last six months",
      },
      {
        title: "Topic Comparison",
        message: "What are the search interest differences between top topics",
      },
    ],
  },
  research: {
    id: "research",
    welcomeMessage: "component.agent.research.title",
    inputPlaceholder: "component.agent.research.input.analyze",
    suggestionCountToShow: 3,
    suggestions: [
      {
        title: "Share of Search Dashboard",
        message: "Activate Share of Search analysis",
      },
      {
        title: "Know what people are asking",
        message: "Activate questions analysis",
      },
      {
        title: "Brand Tracking",
        message: "Activate share of search analysis",
      },
    ],
    flowTypes: {
      "Analyze brand awareness and performance metrics for our consumer product brand in the market":
        "brand1",
      "What are the brand awareness and performance indicators for our B2B SaaS platform in the industry":
        "brand2",
      "Investigate emerging trends and patterns in our consumer product category":
        "brand3",
      "Tell me about the emerging trends and patterns in the B2B SaaS market category":
        "brand4",
    },
    alignInputIfEmpty: true,
  },
};
